<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <EarlyCashbackTable />
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  </div>

</template>

<script>
  import EarlyCashbackTable from './EarlyCashbackTable.vue'

  export default {
    name: 'whitelist',
    components: {EarlyCashbackTable}
  }
</script>



// WEBPACK FOOTER //
// src/views/jeetPrivilege/cashback/earlyCashback/EarlyCashback.vue